import { IsString, MaxLength } from 'class-validator';

export class QualificationSearchDTO {

    @IsString()
    @MaxLength(50)
    name: string;

}
